module.exports = __webpack_public_path__ + "img/default-video.ab2e1d03.png";